import { registerSW } from 'virtual:pwa-register';

export interface PwaCallbacks {
    /** נמצאה גרסה חדשה. מציגים באנר — לא מחליפים גרסה מתחת לרגליים של מי שבאמצע קרב. */
    readonly onNeedRefresh: () => void;
    /** ההתקנה למטמון הסתיימה, מכאן המשחק עובד גם בלי רשת. */
    readonly onOfflineReady: () => void;
}

/** מחזיר פונקציה שמחילה את העדכון; קריאה עם true גם טוענת מחדש. */
export function initPwa(callbacks: PwaCallbacks): (reloadPage?: boolean) => Promise<void> {
    return registerSW({
        immediate: true,
        onNeedRefresh: callbacks.onNeedRefresh,
        onOfflineReady: callbacks.onOfflineReady,
    });
}
